/************************************
MODULE:         Responsible with javascripting links
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {
    
    function init() {
        initLinks();
        
        $(window).off('links:init');
        $(window).on('links:init', initLinks);
    }

    function initLinks() {
        var jsLinks = $('.js-deferred').not('.js-inited');
        if (!jsLinks.length) {
            return;
        }
        jsLinks.addClass('js-inited');

        jsLinks.off('click');
        jsLinks.on('click', { tabLinks: jsLinks }, jsLinkClick);
    }
    
    function jsLinkClick(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        var urlToNavigate = $(this).attr('data-hob');
        if (!urlToNavigate) {
            return false;
        }

        var target = "_blank";
        if (urlToNavigate.startsWith('/')) {
            target = '_self';
        }

        window.open(urlToNavigate, target);
    }
    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.links.js
 ** module id = 42
 ** module chunks = 24
 **/